import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import cx from "classnames";

import global from "../../../scss/dhp.scss";

import { Icon } from "../../ui/icon";
import Settings from "./Settings";

let style = Object.assign({}, global);

const PublishModal = ({ document: data, _helpers, documentrawData }) => {
  return (
    <React.Fragment>
      <h4 className={cx(style["fw-7"], style["mb-4"])}>Publish and Share</h4>
      <Link to="#" className={cx(style["cross-modal"], style["rounded"])} onClick={_helpers?.modal?.toggle}>
        <Icon icon="ui-close" />
      </Link>

      <Settings source={"publish-modal"} data={data} _helpers={_helpers} documentrawData={documentrawData} />
    </React.Fragment>
  );
};

PublishModal.propTypes = {
  document: PropTypes.object.isRequired,
  _helpers: PropTypes.object.isRequired,
  documentrawData: PropTypes.object,
};

export default PublishModal;
